import { SupabaseService } from "../../../server/supabase/base-supabase-service";

export class SupabaseChatMomentService extends SupabaseService<"chat_moment"> {
  table = "chat_moment" as const;
}
